import { authService } from '@/auth/auth.service';
import { makeEndpointFnsFactory } from '@whiz-cart/node-shared/endpoint/index';

export const makeEndpointFns = makeEndpointFnsFactory(() => config?.backends, fetchAccessToken);

async function fetchAccessToken(refresh?: boolean) {
    if (refresh) {
        authService.accessToken.invalidate();
    }
    const accessToken = await authService.accessToken.get();
    return accessToken ?? null;
}
